import { render, staticRenderFns } from "./BAutocompletePermissionType.vue?vue&type=template&id=241c7d42&"
import script from "./BAutocompletePermissionType.vue?vue&type=script&lang=js&"
export * from "./BAutocompletePermissionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports